import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function LoadingButton({
  onClick,
  children,
  className = '',
  loadingText = 'Please wait...',
  disabled: externallyDisabled = false,
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading || externallyDisabled) return;

    setLoading(true); // start loading immediately

    try {
      // Wrap in Promise.resolve so even sync functions work with await
      await Promise.resolve(onClick());
    } catch (err) {
      console.error('❌ Button error:', err);
    } finally {
      // Always show at least 300ms to avoid flicker
      setTimeout(() => setLoading(false), 300);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading || externallyDisabled}
      className={`${className} ${
        loading || externallyDisabled
          ? 'bg-gray-400 cursor-not-allowed hover:bg-gray-600'
          : 'bg-black hover:bg-purple-600'
      }`}
    >
      {loading ? loadingText : children}
    </button>
  );
}

LoadingButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  loadingText: PropTypes.string,
  disabled: PropTypes.bool,
};
